/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2024-11-04 14:47:47                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2025-02-17 14:57:34                               *
 *****************************************************************************/

/* SUMMARY
  * Imports
  * Components
  * Styles
  * Event: event display component
*/

/* Imports */
import React from "react";
import { Typography } from "@material-tailwind/react";

/**
* Event: event display component
* @param className - additional class name 
*/
export default function Header(props: any) {
  const { label } = props;

  
  return (
    <>
      {label && label.split(" ").length > 1 &&
        <span className="ml-2">
          <Typography variant="h2" >
          {label.split(" ")[0]}
          </Typography> 
          <Typography variant="lead" >
            {label.split(" ")[1]}
          </Typography> 
        </span>
      }
      {label && label.split(" ").length === 1 &&
        <span className="m-auto">
          <Typography variant="lead">
            {label}
          </Typography>
        </span> 
      }  
    </>
  );
}